module.exports = __webpack_public_path__ + "img/500.04827eff.png";